// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { Typography } from "@insite/mobius/index";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@werner/App/Components/Common/XngZone";
import { DivWrapper } from "@werner/XDL/constants";
import { color, xScreen } from "@werner/XDL/Utilities";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

interface SignInPageLayoutStyles {
    container?: InjectableCss;
}

const signInPageLayout: SignInPageLayoutStyles = {
    container: {
        css: css`
            display: flex;
            padding: 50px;
            box-shadow: 0 0 15px 0 ${color("primary", 0.15)};
            position: relative;
            column-gap: 100px;
            .line-seperator {
                background-color: ${color("common.ui2")};
                position: absolute;
                width: 1px;
                height: calc(100% - 100px);
                left: 50%;
                top: 50px;
                transform: translateX(-50%);
                ${xScreen("lte", "md")} {
                    width: 50%;
                    height: 1px;
                    top: 67%;
                    left: 25%;
                    transform: translateY(-50%);
                }
                ${xScreen("lte", "sm")} {
                    width: 100%;
                    left: 0;
                }
            }

            ${xScreen("lte", "md")} {
                flex-direction: column;
                padding: 50px 0px;
            }
        `,
    },
};

const styles = signInPageLayout;
const SignInPageLayout: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="SignInPageLayout">
            <XngZone contentId={id} zoneName="Content00" hint="SignInExistingAccount" />
            <Typography as="div" className="line-seperator"></Typography>
            <XngZone contentId={id} zoneName="Content01" hint="CreateAccount" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SignInPageLayout,
    definition: {
        group: "Layout" as any,
        displayName: "SignIn page layout",
        allowedContexts: ["SignInPage"],
    },
};

export default widgetModule;
